<template>
    <div class="flex w-full font-primary" v-if="permiso">
      <div class="w-20 md:w-40 border-black-500 border-r p-2 ml-2">
        <RouterLink to="/admin/home" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/hogar.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Home</p>
        </RouterLink>
        <RouterLink to="/admin/usuarios" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/usuario.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Usuarios</p>
        </RouterLink>
        <!-- <RouterLink to="/admin/contactos" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/correo.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Contactos</p>
        </RouterLink> -->
        <RouterLink to="/admin/pedidos" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/carrito.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Pedidos</p>
        </RouterLink>
        <RouterLink to="/admin/productos" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/bolsa.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Productos</p>
        </RouterLink>
        <RouterLink to="/admin/certificados" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/correo.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Certificados</p>
        </RouterLink>
        <RouterLink to="/admin/configuracion" class="flex align-center py-4 gap-1">
            <img src="../assets/icons/ajuste.png" alt="hogar logo" class="w-6">
            <p class="hidden md:block">Configuración</p>
        </RouterLink>
      </div>
      <router-view class="w-full overflow-x-auto"></router-view>
    </div>
  </template>
  
  <script>
  import usuarioService from '@/services/usuario.service'
  export default {
    data() {
      return {
        permiso: false
      };
    },
    computed: {
    },
    methods: {
        checkPermision() {
          var user = JSON.parse(localStorage.getItem('user'))
          usuarioService.getUserCheckAdminId(user.id)
            .then((res) => {
              if (!res.data) {
                this.$router.push('/catalogo')
              } else {
                this.permiso = true
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
    },
    mounted() {
      this.checkPermision()
    },
  };
  </script>

